<template>
    <div>
        <hg-dialog title="瞬时流量计查询" :width="480" :height="400" :visible="dialogVisible" @close="handleClose">
            <div v-loading="loading" style="width: 100%;height: 100%;">
                <pannel :value="pntValue" :pntName="pntName"></pannel>
            </div>
            <div slot="footer" style="width:100%;text-align: right">
                <el-button size="small" icon="el-hg-icon-close" type="danger" @click="handleClose">关 闭</el-button>
            </div>
        </hg-dialog>
    </div>
</template>
<script>
import HgDialog from '@/components/dialog';
import axios from 'axios';
import pannel from './pannel.vue'

// const
export default {
    name: 'MyDialog',
    components: {
        HgDialog,
        pannel
    },
    props: {
        pntName: {
            type: String,
            default: ''
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            loading: false,
            dType: {
                insert: '通用字典配置新增',
                update: '通用字典配置修改',
                detail: '通用字典配置详情'
            },
            originData: {}, // 副本，判断是否更改数据
            pntValue: 0,
            // pntName: 'csssss',
            time: null
        };
    },
    methods: {
        async save(param) {
        },
        async getDetail() {
            if (!this.pntName || this.pntName == '') {
                return;
            }
            // this.loading = true;
            let res = await axios({
                method: 'get',
                url: '/hnApi/iotData/getLatestFlowmeterValByTagNum/' + this.pntName,
                responseType: 'stream'
            })
            if (res.data && res.data.data) {
                let data = res.data.data
                this.loading = false;
                this.pntValue = Number(data[0].pntValue);
            } else {
                this.pntValue = 0;
            }

        },
        submit() {
        },
        clearForm() {
            this.pntValue = 0;
        },
        handleClose() {
            if (this.dialogType === 'update' && this.$utils.targetIsChange(this.originData, this.formData)) {
                this.$confirm('是否不保存离开', '提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.clearForm();
                        this.dialogVisible = false;
                        this.$emit('close', 'insert');
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消关闭'
                        });
                    });
            }
            else {
                this.clearForm();
                this.dialogVisible = false;
                this.$emit('close', 'insert');
            }

        }
    },
    // dialog show
    watch: {
        show(val) {
            if (val) {
                this.dialogVisible = true;
                this.getDetail();
                if (this.time) {
                    clearInterval(this.time);
                    this.time = null;
                }
                this.time = setInterval(() => {
                    this.getDetail();
                }, 30000);
            }
            else {
                this.dialogVisible = false;
                if (this.time) {
                    clearInterval(this.time);
                    this.time = null;
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped></style>
